import { ConvertibleAction } from 'types/ConvertibleAction'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { ActionFormWithId } from '../../pages/admin/convertibles/edit-convertible/ActionForm'

export const getConvertibleLoanAmount = (convertible: ConvertibleEntity) => {
    if (!convertible.convertibleActions || convertible.convertibleActions.length === 0) return null

    return convertible.convertibleActions.reduce((acc: number, action: ConvertibleAction | ActionFormWithId) => {
        if (action.actionType === 'new_loan' && action.loanAmount !== null) {
            acc += action.loanAmount
        }
        return acc
    }, 0)
}

export const getConvertibleStatusLabel = (convertible: ConvertibleEntity) => {
    if (convertible.completed) {
        return 'Återbetalt lån'
    }

    const loanAmount = getConvertibleLoanAmount(convertible)
    if (convertible.creditLine !== null && (loanAmount === null || loanAmount === 0)) {
        return 'Onyttjad kreditfacilitet'
    }

    return 'Utestående lån'
}
